import DisclosureTypes from './DisclosureTypes';

export function loadDisclosureTop (data) {
  return {
    type: DisclosureTypes.GET_DISCLOSURE_TOP_REQUEST,
    payload: data
  };
}

export function loadSectionDetail (data) {
  return {
    type: DisclosureTypes.GET_SECTION_DETAIL_REQUEST,
    payload: data
  };
}

export function loadSectionTableHeading (data) {
  return {
    type: DisclosureTypes.GET_SECTION_TABLE_HEADING_REQUEST,
    payload: data
  };
}

export function loadPatientGroupTop (data) {
  return {
    type: DisclosureTypes.GET_PATIENT_GROUP_TOP_REQUEST,
    payload: data
  };
}

export function searchData (data) {
  return {
    type: DisclosureTypes.DO_SEARCH_REQUEST,
    payload: data
  };
}
